export class PathItem {
    public start;
    public end;
    public marker;

    constructor(start, end, marker?) {
        this.start = start;
        this.end = end;
        this.marker = marker;
    }
}